/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePageV2`).
 */

import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import { Redirect, Route, Switch, useLocation } from "react-router-dom";
import { Layout } from "../_theme_parts/layout";
import PublicLayout from "../_theme_parts/layout/components/PublicLayout";
import BasePage from "./BasePage";
import { AuthPage, Logout } from "./modules/Auth";
import ErrorsPage from "./modules/ErrorsExamples/ErrorsPage";
import PublicJobOpenings from "./modules/Openings/PublicJobOpenings";
import SearchJobDetail from "./pages/Candidate/SearchJobDetail";
import PublicJobSearchPage from "./modules/Openings/PublicJobSearchPage";
import SlotSelectionComponent from "./modules/copilot-module/SlotSelection";

export function Routes() {
  const { isAuthorized } = useSelector(
    ({ users }) => ({
      isAuthorized: users.token,
    }),
    shallowEqual
  );
  const pathname = useLocation().pathname;
  const loggedOutUserRole = localStorage.getItem("loggedOutUserRole");
  const redirectPath =
    "/auth/" + (loggedOutUserRole ? loggedOutUserRole + "/" : "") + "login";

  return (
    <Switch>
      <Route
        exact
        path="/openings"
        render={() => (
          <PublicLayout>
            <PublicJobOpenings />
          </PublicLayout>
        )}
      />
      <Route
        path="/openings/:openingId"
        render={() => (
          <PublicLayout>
            <SearchJobDetail />
          </PublicLayout>
        )}
      />

      <Route
        path="/candidate/interview/slot-selection/:sourceId/:timeSlotId/:campaignId/:token"
        render={() => (
          <PublicLayout>
            <SlotSelectionComponent />
          </PublicLayout>
        )}
      />

      {!isAuthorized ? (
        /*Redirect to `/auth` when user is not authorized*/
        pathname.startsWith("/auth") ? (
          <Route>
            <AuthPage />
          </Route>
        ) : (
          <Redirect to={redirectPath} />
        )
      ) : (
        <Layout>
          <BasePage />
        </Layout>
      )}

      {!isAuthorized ? (
        /*Render auth page when user at `/auth` and not authorized.*/
        <>
          <Route>
            <AuthPage />
          </Route>
        </>
      ) : (
        /*Otherwise redirect to root page (`/`)*/
        <Redirect from="/auth" to="/" />
      )}

      <Route path="/error" component={ErrorsPage} />
      <Route path="/logout" component={Logout} />
    </Switch>
  );
}
